import Styles from './BreadCrumbs.module.scss';
import { useNavigate } from 'react-router-dom';
import { Icon } from 'components/lib';

/**
 * Breadcrumbs for pages, auto adds nav breadcrumb first and then the rest
 * @param {*} onClickPaths Respective Link that the page will be taken to when the link is generated
 * @param {*} Crumbs The text or icon that will be displayed with the topgrep blue colour
 * 
 */
export function BreadCrumbs({ onClickPaths, crumbs, disableHome = false, ...props }) {
    const navigate = useNavigate();

    if (onClickPaths.length !== crumbs.length) {
        throw new Error('Length mistmatch for links and crumbs.');
    }

    return (
        <div className={Styles.titleContainer}>
            {!disableHome &&
                <>
                    <span aria-label='home breadcrumb' style={{ cursor: 'pointer' }}
                        onClick={() => navigate('/navigate')}
                    >
                        <Icon image='home' size={18} />
                    </span>
                    <span aria-hidden>
                        {'>'}
                    </span>

                </>
            }
            {crumbs.map((crumb, index) => {
                if (crumb !== '') {
                    return (
                        <div key={crumb + index}>
                            <span
                                aria-label={`${crumb} breadcrumb`}
                                style={{ cursor: onClickPaths[index] !== '' ? 'pointer' : '' }}
                                onClick={() => navigate(onClickPaths[index])}
                            >
                                {crumb}
                            </span>
                            <span aria-hidden>
                                {index !== crumbs.length - 1 ? ' >' : ''}
                            </span>
                        </div>
                    );
                } else {
                    return null; // Skip this iteration
                }
            }
            )}
        </div>
    );
}